import onicecandidate from './icecandidate'
import oniceconnectionstatechange from './iceconnectionstatechange'
import onicegatheringstatechange from './icegatheringstatechange'
import onnegotiationneeded from './negotiationneeded'
import onsignalingstatechange from './signalingstatechange'
import ontrack from './track'

export default {
  onicecandidate,
  oniceconnectionstatechange,
  onicegatheringstatechange,
  onnegotiationneeded,
  onsignalingstatechange,
  ontrack
}
